import bank from "./bank.svg"
import bill from "./bill.svg"
import check from "./check.svg"

import dependents from "./dependents.svg"
import folder from "./folder.svg"
import growth from "./growth.svg"
import hospital from "./hospital.svg"
import link from "./link.svg"
import moneyManagement from "./moneyManagement.svg"
import person_add from "./person_add.svg"
import piggy from "./piggy.svg"
import save from "./save.svg"
import scales from "./scales.svg"
import continu from "./submit.svg"

import submit from "./continue.svg"
import withdraw from "./withdraw.svg"
import ios_share from "./ios_share.svg"
import gift from "./gift.svg"
import group from "./group.svg"
import cloudComputing from "./cloud-computing.svg"
import addUser from "./add-user.svg"
import browserWindow from "./browser-window.svg"
import camera from "./camera.svg"
import forward from "./forward.svg"

const SVGS = {
	bank,
	bill,
	check,
	continu,
	dependents,
	folder,
	growth,
	hospital,
	link,
	moneyManagement,
	person_add,
	piggy,
	save,
	scales,
	submit,
	withdraw,
	ios_share,
	gift,
	group,
	cloudComputing,
	addUser,
	browserWindow,
	camera,
	forward,
} 
export default SVGS
